export const getLoginToken = () => localStorage.getItem('token');

export const addLoginToken = (newToken: string) => localStorage.setItem('token', newToken);

export const removeLoginToken = () => localStorage.removeItem('token');
